import type { ThemeOptions } from '@mui/material';

import { palette } from './config/palette';
import { shape } from './config/shape';
import { typography } from './config/typography';
import { zIndex } from './config/zIndex';

/**
 * Tradeshift MUI theme configuration. Read more at https://mui.com/material-ui/customization/theming/
 */

export const tradeshiftThemeConfig: ThemeOptions = {
	palette,
	shape,
	typography,
	spacing: 10,
	zIndex,
};
